'use client';

import { useEffect } from 'react';
import { getConsent, onConsentChange } from '@/lib/analytics/consent';
import { captureGclidFromUrl } from '@/lib/marketing/gclid';

/**
 * Reads ?gclid=… from the current URL and persists it for 90 days
 * (localStorage + cookie). The signup form then attaches it to the
 * register payload so the server can store it against the new user;
 * the Stripe webhook later reads it back to fire a real "Paid
 * Subscription Started" conversion to Google Ads.
 *
 * DSGVO-gated by the same marketing-cookie consent that gtag uses —
 * if the user denies marketing, we lose attribution rather than
 * persisting tracking data without consent.
 */
export function GclidCapture() {
  useEffect(() => {
    const sync = (): void => {
      if (getConsent()?.marketing) captureGclidFromUrl();
    };
    sync();
    return onConsentChange(sync);
  }, []);
  return null;
}
